/**
 * The below file contains the constants used in the Lightning Inmates Registration
 * @author: vishal.mishra@velsof.com
 * @date :22-01-2025
 */

export const GET_ALL_LIGHTNING_INMATES_REGISTRATION =
  "GET_ALL_LIGHTNING_INMATES_REGISTRATION";
export const SET_ALL_LIGHTNING_INMATES_REGISTRATION =
  "SET_ALL_LIGHTNING_INMATES_REGISTRATION";

export const REPORT_DATE_PARAM = "reportDate";
export const STATUS_PARAM = "status";
export const GET_ALL_CREATE_LIGHTNING_INMATES_REGISTRATION =
  "GET_ALL_CREATE_LIGHTNING_INMATES_REGISTRATION";
export const SET_ALL_CREATE_LIGHTNING_INMATES_REGISTRATION =
  "SET_ALL_CREATE_LIGHTNING_INMATES_REGISTRATION";

export const GET_ALL_UPDATE_LIGHTNING_INMATES_REGISTRATION =
  "GET_ALL_UPDATE_LIGHTNING_INMATES_REGISTRATION";
export const SET_ALL_UPDATE_LIGHTNING_INMATES_REGISTRATION =
  "SET_ALL_UPDATE_LIGHTNING_INMATES_REGISTRATION";

export const SET_LIGHTNING_INMATES_REGISTRATION =
  "SET_LIGHTNING_INMATES_REGISTRATION";

/**Constants for relief camp Import page */
export const CAMP_INMATES_REGISTRATION_IMPORT =
  "LIGHTNING_CAMP_INMATES_REGISTRATION_IMPORT";
export const CAMP_INMATES_REGISTRATION_IMPORT_EXCEL =
  "LIGHTNING_CAMP_INMATES_REGISTRATION_IMPORT_EXCEL";
/**Constants for relief camp Import page */

/**Constants for camp inmates registration export */
export const GET_EXPORT_CAMP_INMATES_DATA =
  "LIGHTNING_GET_EXPORT_CAMP_INMATES_DATA";
export const SET_EXPORT_CAMP_INMATES_DATA =
  "LIGHTNING_SET_EXPORT_CAMP_INMATES_DATA";
/**Constants for camp inmates registration import template */
export const GET_IMPORT_TEMPLATE_CAMP_INMATES_DATA =
  "LIGHTNING_GET_IMPORT_TEMPLATE_CAMP_INMATES_DATA";
export const SET_IMPORT_TEMPLATE_CAMP_INMATES_DATA =
  "LIGHTNING_SET_IMPORT_TEMPLATE_CAMP_INMATES_DATA";
